import { Link } from 'react-router-dom';

export default function CommunitySection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20anime%20style%20illustration%20of%20a%20group%20of%20friends%20gathering%20under%20a%20large%20cherry%20blossom%20tree%20in%20a%20park%20sharing%20stories%20and%20laughing%20soft%20spring%20sunlight%20filtering%20through%20branches%20peaceful%20community%20atmosphere%20pastel%20colors&width=1600&height=800&seq=community-bg&orientation=landscape"
          alt="社区"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
            加入初音岛粉丝社区
          </h2>
          <p className="text-background-200/90 text-sm md:text-base mb-6 leading-relaxed">
            与全球的初音岛爱好者一起，分享您的热爱。参与同人创作、Cosplay展示、线下聚会，找到属于您的樱花树下的伙伴。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/category/community"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap text-center"
            >
              探索社区 <i className="ri-group-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all whitespace-nowrap text-center"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-14">
          {[
            { number: '10,000+', label: '社区成员', icon: 'ri-user-star-line' },
            { number: '500+', label: '同人作品', icon: 'ri-brush-line' },
            { number: '15+', label: '线下活动', icon: 'ri-calendar-event-line' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="text-center p-6 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20"
            >
              <span className="w-10 h-10 flex items-center justify-center mx-auto mb-3 text-accent-400">
                <i className={`${stat.icon} text-2xl`}></i>
              </span>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">
                {stat.number}
              </div>
              <div className="text-sm text-background-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}